import { render, staticRenderFns } from "./admin_feedback.vue?vue&type=template&id=8fe143be&scoped=true&"
import script from "./admin_feedback.vue?vue&type=script&lang=ts&"
export * from "./admin_feedback.vue?vue&type=script&lang=ts&"
import style0 from "./admin_feedback.vue?vue&type=style&index=0&id=8fe143be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fe143be",
  null
  
)

export default component.exports